import CloseRounded from '@mui/icons-material/CloseRounded';
import { Box, IconButton, Stack, Typography } from '@mui/material';
import React from 'react';

export interface ReportEditDialogHeaderProps {
  title: string;
  titleId: string;
  /** Shown beneath the title. The report name is read-only context, not a field. */
  subtitle?: string;
  onClose: () => void;
}

export const ReportEditDialogHeader: React.FC<ReportEditDialogHeaderProps> = ({
  title,
  titleId,
  subtitle,
  onClose,
}) => (
  <Box
    sx={{
      px: 2,
      pt: 2,
      pb: 1.5,
      borderBottom: '1px solid',
      borderColor: 'v4.border',
    }}
  >
    <Stack direction="row" alignItems="flex-start" spacing={1}>
      <Box sx={{ flex: 1, minWidth: 0 }}>
        <Typography id={titleId} variant="subtitle1" sx={{ fontWeight: 600 }}>
          {title}
        </Typography>
        {subtitle && (
          // `title` so a name too long for the header is still readable on hover.
          <Typography
            variant="caption"
            noWrap
            title={subtitle}
            sx={{ color: 'v4.textMuted', display: 'block' }}
          >
            {subtitle}
          </Typography>
        )}
      </Box>
      {/* In the flow rather than absolutely positioned, so it takes a natural
          tab-order slot and can never overlap a long report name. */}
      <IconButton
        size="small"
        aria-label="Close"
        onClick={onClose}
        sx={{ color: 'text.secondary', '&:hover': { bgcolor: 'v4.tableHover' } }}
      >
        <CloseRounded fontSize="small" />
      </IconButton>
    </Stack>
  </Box>
);
